import { leadSourceApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LEAD_SOURCE_ACTION_TYPE = createNamedActions('leadSource', {
  GET_LEAD_SOURCES: 'GET_LEAD_SOURCES',
  ADD_LEAD_SOURCE: 'ADD_LEAD_SOURCE',
  EDIT_LEAD_SOURCE: 'EDIT_LEAD_SOURCE',
  DELETE_LEAD_SOURCE: 'DELETE_LEAD_SOURCE',
});

const leadSource = new schema.Entity('leadSources', {}, { idAttribute: 'leadSourceId' });

export const getLeadSourcesAction = catchAsyncActionError(
  ({ applicationId } = {}) =>
    async dispatch => {
      const { data } = await leadSourceApi.getLeadSourceList({ applicationId });

      return dispatch({
        type: LEAD_SOURCE_ACTION_TYPE.GET_LEAD_SOURCES,
        payload: normalize(data, [leadSource]).entities.leadSources,
      });
    },
);

export const addLeadSourceAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await leadSourceApi.createLeadSource(params);

  return dispatch({
    type: LEAD_SOURCE_ACTION_TYPE.ADD_LEAD_SOURCE,
    payload: data,
  });
});

export const editLeadSourceAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await leadSourceApi.editLeadSource(params);

  return dispatch({
    type: LEAD_SOURCE_ACTION_TYPE.EDIT_LEAD_SOURCE,
    payload: data,
  });
});

export const deleteLeadSourceAction = catchAsyncActionError(params => async dispatch => {
  await leadSourceApi.deleteLeadSource(params);

  return dispatch({
    type: LEAD_SOURCE_ACTION_TYPE.DELETE_LEAD_SOURCE,
    payload: params.leadSourceId,
  });
});
